import React from "react";
import DatePicker from "react-datepicker";


const CustomTimePicker = ({
    selected,
    onChange,
    timeIntervals = 15,
    timeFormat = "h:mm aa",
    placeholderText = "Select time",
    className = "",
    timeCaption = "Time",
    disabled = false,
    showTimeSelect,
    showTimeSelectOnly,
}) => {
    return (
        <DatePicker
            selected={selected}
            onChange={onChange}
            showTimeSelect={showTimeSelect}
            showTimeSelectOnly={showTimeSelectOnly}
            timeIntervals={timeIntervals}
            timeCaption={timeCaption}
            dateFormat={timeFormat}
            placeholderText={placeholderText}
            className={className}
            disabled={disabled}
        />
    );
};

export default CustomTimePicker;
